export const PRICE_LABEL_SIZE = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};
